/* @jsx h */
import { fetchCustomerSession } from "@app/server/client";
import { defineComponent, onMounted, provide, ref, type Ref, h } from "vue";
import {
  AuthenticationComponent,
  AuthenticationState,
} from "../components/Auth";
import { AuthContextKey, AuthSession, AuthContextType } from "./auth-context";

export { useCustomer } from "./auth-context";

// Provide Component
export const AuthProvider = defineComponent<{}>({
  setup(_, { slots }) {
    const customer = ref<AuthSession | null>(null);
    const loaded = ref(false);
    const authState = ref<AuthenticationState>();

    const fetchData = async () => {
      const resp = await fetchCustomerSession();
      setCustomer(resp);
      loaded.value = true;
      return resp;
    };

    onMounted(() => {
      const url = new URL(window.location.href);
      const providers = ["apple", "google"] as const;
      const failed = providers.find(
        (provider) => url.searchParams.get(`${provider}_auth`) === "failed",
      );
      if (failed) {
        authState.value = { oauthFailed: failed };
      }
      if (
        providers.some((provider) => url.searchParams.has(`${provider}_auth`))
      ) {
        providers.forEach((provider) =>
          url.searchParams.delete(`${provider}_auth`),
        );
        window.history.replaceState(
          {},
          "",
          `${url.pathname}${url.search}${url.hash}`,
        );
      }
      fetchData();
    });

    const setCustomer = (newUser: AuthSession | null) => {
      customer.value = newUser;
    };
    const showAuthDialog = (email?: string) => {
      //
      authState.value = { email };
    };

    provide(AuthContextKey, {
      customer,
      setCustomer,
      showAuthDialog,
      refresh: async () => {
        return fetchData();
      },
    });

    // Render the children passed to AuthProvider
    return () => {
      return (
        <>
          {loaded.value ? slots.default?.() : null}
          {authState.value ? (
            <AuthenticationComponent
              state={authState as Ref<AuthenticationState>}
              onClose={() => {
                authState.value = undefined;
              }}
            />
          ) : null}
        </>
      );
    };
  },
});
